

export class EmployeeByUnitDTO {
    employeeId: number; 
    employeeCode:string;
    employeeName: string;
    designation:string;

}